import React, { useState } from 'react';
import { ExitIntentPopup } from './ExitIntentPopup';
import { trackAddToCart } from '../utils/metaPixel';
const BASE_PRICE = 16990;
const BUMP_PRICE = 4500;
function formatPrice(n: number): string {
  return n.toLocaleString('es-AR');
}
export function Price() {
  const [bumpAdded, setBumpAdded] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const totalPrice = bumpAdded ? BASE_PRICE + BUMP_PRICE : BASE_PRICE;
  const handleCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    if (bumpAdded) {
      // Bump is checked — fire AddToCart with bump and redirect
      trackAddToCart({
        content_name: 'El Método Barrita Pro + Guía Mantequilla',
        value: BASE_PRICE + BUMP_PRICE,
        currency: 'ARS'
      });
      window.location.href = 'https://ebookpromax.com/cart/add?id=46723935535262&quantity=1';
    } else {
      // No bump — show exit intent popup
      setShowPopup(true);
    }
  };
  const handleAcceptBundle = () => {
    trackAddToCart({
      content_name: 'El Método Barrita Pro — Paquete Completo',
      value: 20140,
      currency: 'ARS'
    });
    setShowPopup(false);
    window.location.href = 'https://ebookpromax.com/cart/add?id=46723936026782&quantity=1';
  };
  const handleDecline = () => {
    trackAddToCart({
      content_name: 'El Método Barrita Pro',
      value: BASE_PRICE,
      currency: 'ARS'
    });
    setShowPopup(false);
    window.location.href = 'https://ebookpromax.com/cart/add?id=46723935371422&quantity=1';
  };
  return <section className="bg-[#0F172A] py-12 sm:py-20 px-4 text-center relative overflow-hidden" id="comprar" data-id="element-153">
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#22C55E] via-[#F97316] to-transparent" data-id="element-154" />

      <div className="max-w-[780px] mx-auto" data-id="element-155">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-156" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-white tracking-tight leading-[1.2]" data-id="element-157">
          Invertí menos que en 5 barritas de quiosco
        </h2>

        <p className="text-center text-[#94A3B8] text-[15px] mb-9" data-id="element-158">
          Y fabricá miles por el resto de tu vida
        </p>

        <div className="bg-[#1E293B] border-[1.5px] border-[rgba(34,197,94,0.25)] rounded-[28px] py-12 px-6 sm:px-9 max-w-[480px] mx-auto shadow-[0_32px_80px_rgba(0,0,0,0.4),inset_0_1px_0_rgba(255,255,255,0.04)] relative overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:bg-gradient-to-r before:from-transparent before:via-[#22C55E] before:to-transparent" data-id="element-159">
          <p className="text-[17px] text-[#64748B] line-through mb-1.5" data-id="element-160">
            Valor real: $53.000
          </p>

          {/* Dynamic price */}
          <p className="font-montserrat text-[72px] font-black text-white leading-none my-[10px] tracking-tight transition-all duration-300" data-id="element-161">
            <span className="text-2xl font-bold text-[#F97316] align-super" data-id="element-162">
              $
            </span>
            {formatPrice(totalPrice)}
          </p>

          <p className="text-[13px] text-[#64748B] mb-6 tracking-[0.3px]" data-id="element-163">
            Pago único — Sin cuotas mensuales — Acceso inmediato
          </p>

          <div className="bg-[rgba(249,115,22,0.12)] text-[#F97316] border border-[rgba(249,115,22,0.35)] font-montserrat text-xs font-bold tracking-[1.5px] uppercase py-[9px] px-5 rounded-md mb-7 inline-block" data-id="element-164">
            ⚡ OFERTA DE LANZAMIENTO — Solo por hoy
          </div>

          {/* ── ORDER BUMP ── */}
          <div className={`bump-shimmer mt-7 rounded-2xl border-2 text-left transition-all duration-300 overflow-hidden ${bumpAdded ? 'border-[#22C55E] !bg-[rgba(34,197,94,0.06)]' : 'border-[rgba(249,115,22,0.5)]'}`} style={bumpAdded ? {
          background: 'rgba(34,197,94,0.06)',
          animation: 'none'
        } : {}} data-id="element-165">
            {/* Header */}
            <div className={`px-4 py-3 transition-colors duration-300 ${bumpAdded ? 'bg-[#22C55E]' : 'bg-[#F97316]'}`} data-id="element-166">
              <p className="font-montserrat text-[12px] sm:text-[13px] font-extrabold text-white leading-snug tracking-wide text-center" data-id="element-167">
                🥜 ¡ESPERÁ! NO TIRES TU PLATA EN EL SUPERMERCADO...
              </p>
            </div>

            {/* Body */}
            <div className="p-4" data-id="element-168">
              {/* Top row: checkbox + image + title/price */}
              <label className="flex items-center gap-3 cursor-pointer mb-3" onClick={() => setBumpAdded(!bumpAdded)} data-id="element-169">
                {/* Checkbox */}
                <div className={`w-6 h-6 rounded border-2 flex items-center justify-center flex-shrink-0 transition-all duration-200 ${bumpAdded ? 'bg-[#22C55E] border-[#22C55E]' : 'border-[#64748B] bg-transparent'}`} data-id="element-170">
                  {bumpAdded && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-171">
                      <polyline points="20 6 9 17 4 12" data-id="element-172" />
                    </svg>}
                </div>

                {/* Image */}
                <img src="https://cdn.magicpatterns.com/uploads/wA6QkEngSV7d3y9fpi8LqH/FOTO_ORDER_BUMP.png" alt="Guía Mantequilla de Maní Oro Líquido" className="w-14 h-14 rounded-lg object-cover flex-shrink-0" data-id="element-173" />

                {/* Title + Price */}
                <div className="flex-1 min-w-0" data-id="element-174">
                  <p className="font-montserrat text-[14px] font-bold text-white leading-tight" data-id="element-175">
                    Guía "Mantequilla de Maní Oro Líquido"
                  </p>
                  <p className="mt-1" data-id="element-176">
                    <span className={`font-montserrat text-[14px] font-bold ${bumpAdded ? 'text-[#22C55E]' : 'text-[#F97316]'}`} data-id="element-177">
                      + $4.500
                    </span>
                    <span className="text-[#64748B] line-through text-xs ml-2" data-id="element-178">
                      $9.000
                    </span>
                  </p>
                </div>
              </label>

              {/* Description */}
              <p className="text-[13px] text-[#94A3B8] leading-[1.65] pl-9" data-id="element-179">
                Agregá esta guía y aprendé a fabricar tu propia mantequilla
                ultra-cremosa en{' '}
                <strong className="text-white" data-id="element-180">2 minutos</strong> con{' '}
                <strong className="text-white" data-id="element-181">solo un ingrediente</strong>. Sin
                azúcar, sin aceites agregados. Hacé que tus barritas pasen de
                "ricas" a "adictivas" ahorrando el doble.
              </p>

              {/* CTA text */}
              <p className={`mt-3 pl-9 font-montserrat text-[11px] font-bold uppercase tracking-[1px] transition-colors duration-200 ${bumpAdded ? 'text-[#22C55E]' : 'text-[#F97316]'}`} data-id="element-182">
                {bumpAdded ? '✓ ¡Guía agregada a tu pedido!' : 'Tocá para agregar a tu pedido'}
              </p>
            </div>
          </div>

          <a href="#" onClick={handleCheckout} className="block text-center bg-[#F97316] text-white font-montserrat text-[15px] font-extrabold uppercase tracking-[1.5px] py-[18px] px-11 rounded-lg border-none cursor-pointer no-underline transition-all duration-[0.25s] hover:bg-[#C2410C] hover:shadow-[0_8px_32px_rgba(249,115,22,0.45)] hover:-translate-y-0.5 active:translate-y-0 mt-7" style={{
          animation: 'pulse-cta 2.5s ease infinite'
        }} data-id="element-183">
            AGREGAR AL CARRITO &gt;&gt;
          </a>

          {/* ── ORDER SUMMARY (visible when bump is added) ── */}
          {bumpAdded && <div className="mt-6 rounded-xl border border-[rgba(255,255,255,0.08)] bg-[rgba(15,23,42,0.5)] text-left overflow-hidden transition-all duration-300" data-id="element-184">
              <div className="px-5 pt-5 pb-2" data-id="element-185">
                <p className="font-montserrat text-[11px] font-bold uppercase tracking-[1.5px] text-[#94A3B8] mb-4" data-id="element-186">
                  Resumen de tu pedido
                </p>

                <div className="flex justify-between items-center py-2.5 border-b border-[rgba(255,255,255,0.06)]" data-id="element-187">
                  <span className="text-[14px] text-[#94A3B8]" data-id="element-188">
                    El Método Barrita Pro
                  </span>
                  <span className="text-[14px] text-[#64748B] line-through" data-id="element-189">
                    $28.000
                  </span>
                </div>

                <div className="flex justify-between items-center py-2.5 border-b border-[rgba(255,255,255,0.06)]" data-id="element-190">
                  <span className="text-[14px] text-[#94A3B8]" data-id="element-191">
                    6 Bonos Incluidos
                  </span>
                  <span className="text-[14px] text-[#64748B] line-through" data-id="element-192">
                    $25.000
                  </span>
                </div>

                <div className="flex justify-between items-center py-2.5 border-b border-[rgba(255,255,255,0.06)]" data-id="element-193">
                  <span className="text-[14px] text-[#22C55E]" data-id="element-194">
                    Guía Mantequilla de Maní
                  </span>
                  <span className="text-[14px] text-white" data-id="element-195">$4.500</span>
                </div>
              </div>

              <div className="px-5 py-3 border-t border-[rgba(255,255,255,0.1)]" data-id="element-196">
                <div className="flex justify-between items-center mb-2" data-id="element-197">
                  <span className="font-montserrat text-[14px] font-bold text-white" data-id="element-198">
                    Valor Total
                  </span>
                  <span className="text-[15px] text-[#64748B] line-through font-semibold" data-id="element-199">
                    $57.500
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-200">
                  <span className="font-montserrat text-[15px] font-extrabold text-[#F97316]" data-id="element-201">
                    Hoy pagás solo
                  </span>
                  <span className="font-montserrat text-[22px] font-black text-white" data-id="element-202">
                    ${formatPrice(totalPrice)}
                  </span>
                </div>
              </div>
            </div>}
        </div>
      </div>

      {/* Exit Intent Popup */}
      {showPopup && <ExitIntentPopup onAccept={handleAcceptBundle} onDecline={handleDecline} data-id="element-203" />}
    </section>;
}